export default "__VITE_ASSET__90aa5876__"